import { render, staticRenderFns } from "./second-trade.vue?vue&type=template&id=31b673ef&scoped=true&"
import script from "./second-trade.vue?vue&type=script&lang=js&"
export * from "./second-trade.vue?vue&type=script&lang=js&"
import style0 from "./second-trade.vue?vue&type=style&index=0&id=31b673ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b673ef",
  null
  
)

export default component.exports